module.exports = __webpack_public_path__ + "img/9791162334126.8fb15227.jpg";